import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import AppRoutes from './routes';
import WaralsMainLayout from "./WaralsAdmin/src/layout/MainLayout";
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

const App = () => {
  return (
    <Router>
      <ScrollToTop />

      <Routes>
        {/* ✅ Warals Route Added Properly */}
        

        {/* Existing App Routes */}
        <Route path="/*" element={<AppRoutes />} />
      </Routes>

    </Router> 
  );
};

export default App;